/*
 * @Author       : Duanjiaojiao
 * @Date         : 2023-08-21 16:49:04
 * @LastEditors  : yilingui
 * @LastEditTime : 2026-02-02 20:10:41
 * @Description  :
 * @FilePath     : /BM-Main/src/utils/lego/legoInitParams.js
 */
import { legoInit } from '@zz-common/lego'
import { cookie, url } from '@zz-common/zz-utils'
import { legoRouteList } from '@/router'

export default () => {
  // 埋点初始化，解析参数，避免携带不必要参数
  try {
    const params = url.getParams()

    let pageQuery = ''
    const { channel, windowSessionId } = params || {}
    const { __model, __brand } = url.getParams() || {}
    const machineModel = __model || cookie.get('model')
    const machineBrand = __brand || cookie.get('brand')
    const lon = cookie.get('lon')
    const lat = cookie.get('lat')

    const query = [
      'channel',
      'cateGroupId',
      'cateId',
      'brandId',
      'modelId',
      'orderId',
      'preQcCode',
      'parentCateId',
      'bmFrom',
      'sceneType',
      'windowSessionId',
      'positionid',
      'modelPageSceneId'
    ]
    for (const key of query) {
      const value = params[key]
      if (value) {
        pageQuery = `${pageQuery}&${key}=${value}`
      }
    }
    pageQuery = pageQuery ? pageQuery.substr(1) : ''
    console.log('pageQuery: ', pageQuery)
    legoInit(
      Object.assign(
        {},
        {
          pagequery: pageQuery,
          routeList: legoRouteList,
          channel,
          mchannel: channel,
          windowSessionId,
          machineModel,
          machineBrand,
          stayUserTime: true,
          setCloseMark: true,
          log: false,
          lat,
          lon,
          forbidLegoInPrerender: true
        }
      )
    )
  } catch (error) {
    console.log('111 error: ', error)
  }
}
